<template>
  <div>User RBAC</div>
</template>

<script>
export default {};
</script>
